export default __webpack_public_path__ + "static/media/bg3.17916fb6.png";